import React from "react";
import { TableInput, ImgInput } from "components/common/input";
import { ITableSetting } from "service/interface/digital";

interface Props {
  data: ITableSetting;
  setData: React.Dispatch<React.SetStateAction<ITableSetting>>;
}

export function DetailInfoTable({ data, setData }: Props) {
  const handleTitleInput = (e: React.ChangeEvent<HTMLInputElement>) => {
    setData((prev) => ({
      ...prev,
      title: e.target.value,
    }));
  };

  return (
    <div>
      <div className="mb-[24px] flex items-center justify-between">
        <p className="m-0 text-[24px] font-semibold leading-[30px] text-black">
          이미지 정보
        </p>
      </div>
      <div className="w-full border-t-[2px] border-t-black p-0">
        <div className="flex h-[86px] w-full border-b-[1px] border-b-gray-1">
          <div className="flex h-full w-[148px] items-center justify-center bg-[#f4f4f4] text-M3 text-gray-4">
            제목
          </div>
          <div className="flex h-full w-[787px] items-center px-[12px] text-M3 text-gray-5">
            <TableInput
              value={data.title}
              onChange={handleTitleInput}
              placeholder="제목을 입력해 주세요"
            />
          </div>
        </div>
        <div className="flex h-[272px] w-full border-b-[1px] border-b-gray-1">
          <div className="flex h-full w-[148px] items-center justify-center bg-[#f4f4f4] text-center text-M3 text-gray-4">
            이미지 등록
          </div>
          <div className="flex h-full w-[787px] items-center px-[12px] text-M3 text-gray-5">
            <ImgInput data={data} setData={setData} name="imgSrc" />
          </div>
        </div>
      </div>
    </div>
  );
}
